import './index.css'
import cn from 'clsx'
import React from 'react'
import { MdPause } from '@react-icons/all-files/md/MdPause'
import { MdPlayArrow } from '@react-icons/all-files/md/MdPlayArrow'
import { MdRemoveRedEye } from '@react-icons/all-files/md/MdRemoveRedEye'
import { connect } from 'react-redux'
import type { Track } from 'types/track'
import type { TrackLocation } from 'types/ui'
import type { TrackOptions } from '@disco/state-management/actions/MediaActions'
import * as MediaActions from '@disco/state-management/actions/MediaActions'
import GoogleAnalytics from '@disco/api/ga'
import mixpanel from '@disco/api/mixpanel'
import { AUDIO_FILE, DRM_FILE, VIDEO_FILE } from '@disco/constants/FileTypes'
import { LOADED, LOADING, PLAYING } from '@disco/constants/MediaStatus'
import { getTrackPlaybackStatus } from '@disco/state-management/selectors/media'
import { getTrack } from '@disco/state-management/selectors/tracks'
import { getFileTypeByExt } from '@disco/utils/file-utils'
import { attachGallery, getGalleryImages } from '@disco/utils/gallery'
import LoadingIndicator from 'components/common/copy-metadata-track/loading-indicator'

function mapStateToProps(state, { trackId }) {
  // const getTrackPlaybackStatus = makeGetTrackPlaybackStatus()
  // const getTrack = getTrack()
  return {
    ...getTrackPlaybackStatus(state, {
      trackId,
    }),
    currentTrack: getTrack(state, {
      id: trackId,
    }),
  }
}

type Props = {
  // TODO: pass less props, for that use TrackOptions / TrackEventOptions
  ext: string | null | undefined
  track: Track
  trackId: number
  size: ('small' | 'large') | null | undefined
  loadStatus: string
  location?: TrackLocation
  // deprecated in favour of playbackContext
  disabled?: boolean
  sourcePlaylistId: number | null | undefined
  // deprecated in favour of playbackContext
  sourceShortlistId?: string | null | undefined
  // deprecated in favour of playbackContext
  playbackStatus: string
  playbackContext: TrackOptions
  shareId?: number | null | undefined
  // deprecated in favour of playbackContext
  groupId: number | null | undefined
  // deprecated in favour of playbackContext
  clientLibraryId?: number | null | undefined
  // deprecated in favour of playbackContext
  mediaSource: string
  // deprecated in favour of playbackContext
  paneIndex: number | null | undefined
  // deprecated in favour of playbackContext
  campaignId?: number | null | undefined
  // deprecated in favour of playbackContext
  recipientId?: number | null | undefined
  // deprecated in favour of playbackContext
  playTrack: (...args: Array<any>) => any
  pauseTrack: (...args: Array<any>) => any
  onOpenPreview?: (...args: Array<any>) => any
  disabledLightgallery?: boolean
  playIcon?: React.ReactNode
}

class Playbar2 extends React.Component<Props> {
  _handlePreviewClick = (e: React.SyntheticEvent<any>) => {
    e.stopPropagation()
    e.preventDefault()
    const { id, name, previews } = this.props.track
    const { location, onOpenPreview, disabledLightgallery } = this.props
    if (onOpenPreview) onOpenPreview(name, previews)
    if (disabledLightgallery) return
    const galleryImages = getGalleryImages(name, previews)
    attachGallery(`gallery-${id}`, galleryImages)
    const event =
      location === 'public-playlist' || location === 'public-track'
        ? 'Preview non-media file on public page'
        : 'Preview non-media file in app'
    mixpanel.sendPureEvent(event)

    if (location === 'public-playlist') {
      GoogleAnalytics.sendEvent(
        'Other',
        'Preview non-media file on playlist page',
      )
    }

    if (location === 'public-track') {
      GoogleAnalytics.sendEvent('Other', 'Preview non-media file on track page')
    }
  }
  _handleControlsClick = (e: React.SyntheticEvent<any>) => {
    const fileType = getFileTypeByExt(this.props.ext)
    if (fileType === DRM_FILE || this.props.disabled) return
    // don't handle clicks when status is loading to prevent exceptions throwing
    if (this.props.loadStatus === LOADING) return
    e.stopPropagation()
    e.preventDefault()
    // TODO: handle location
    const {
      trackId,
      sourcePlaylistId: playlistId,
      sourceShortlistId: shortlistId,
      clientLibraryId,
      shareId,
      groupId,
      mediaSource,
      paneIndex,
      campaignId,
      recipientId,
    } = this.props

    if (this.props.playbackStatus !== PLAYING) {
      this.props.playTrack(trackId, mediaSource, {
        playbackLocation:
          mediaSource === 'public-track-page' ? 'Track page' : 'Playlist page',
        playlistId,
        shortlistId,
        clientLibraryId,
        shareId,
        groupId,
        paneIndex,
        campaignId,
        recipientId,
        ...this.props.playbackContext, // TODO: pass everything through playbackContext
      })
    } else {
      this.props.pauseTrack(trackId)
    }
  }

  render() {
    const { playbackStatus, loadStatus, size, ext, track, playIcon } =
      this.props
    const fileType = getFileTypeByExt(ext)
    let icon, handler, isAudioVideo, isDocument

    if (fileType === AUDIO_FILE || fileType === VIDEO_FILE) {
      handler = this._handleControlsClick
      isAudioVideo = true

      if (playbackStatus === PLAYING && loadStatus === LOADED) {
        icon = <MdPause />
      } else {
        icon = playIcon || <MdPlayArrow />
      }
    } else {
      handler = this._handlePreviewClick
      isDocument = true
      icon = <MdRemoveRedEye />
    }

    const isPlaying = playbackStatus === PLAYING || loadStatus === LOADING
    const contCls = cn('PlayerBar2', {
      'is-small': size === 'small',
      'is-playing': isPlaying,
      'is-audiovideo': isAudioVideo,
      'is-document': isDocument,
    })
    return (
      <div id={`gallery-${track.id}`} onClick={handler}>
        <div
          className="e2col-tr-play-overlay"
          data-is-playing={isPlaying || null}
        />
        <div className="e2col-tr-play" data-is-playing={isPlaying || null}>
          <div className={contCls}>
            {loadStatus === LOADING ? (
              <LoadingIndicator size="medium" />
            ) : (
              <div className="PlayerBar2-icon">{icon}</div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, MediaActions)(Playbar2) as any
